import * as React from 'react';
import classnames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import CreatorProposalNotes from '../notes/CreatorProposalNotes';

import { __t, applyTranslations } from 'utils/language';

import type { ProposalTileNotes } from 'modules/proposal/types/ProposalTile.type';

import './proposal-tile-footer.scss';

applyTranslations(require('./proposal-tile-footer.i18n.json'));

type Props = {
  isForBrand: boolean,
  notes?: ProposalTileNotes,
  onNoteUpdate: (note?: string | null) => void,
  children?: React.ReactNode
};

const ProposalTileFooter = (
  {
    isForBrand,
    notes,
    onNoteUpdate,
    children
  }: Props
): JSX.Element => {
  const shouldNotesBeExpanded = Boolean(notes?.accountManager || notes?.brandRepresentative);
  const [isNoteExpanded, setNoteExpanded] = React.useState(shouldNotesBeExpanded);

  const expandIconClassNames = classnames('proposal-tile-footer__notes-expand-icon', {
    'proposal-tile-footer__notes-expand-icon--expanded': isNoteExpanded
  });
  const notesSectionClassNames = classnames('proposal-tile-footer__notes', {
    'proposal-tile-footer__notes--hidden': !isNoteExpanded
  });

  return (
    <React.Fragment>
      <div className="proposal-tile-footer">
        <div
          className="proposal-tile-footer__notes-expand-block"
          onClick={() => setNoteExpanded(!isNoteExpanded)}
        >
          <div className={expandIconClassNames}>
            <SVGDynamicIcon
              width={13}
              height={6}
              name="chevron-down-custom-fg"
            />
          </div>
          <span className="proposal-tile-footer__notes-expand-label">
            {__t('proposal_tile_footer.notes_label')}
          </span>
        </div>

        <div className="proposal-tile-footer__expander" />

        {children}
      </div>
      <div className={notesSectionClassNames}>
        <div className="proposal-tile-footer__notes-content">
          <CreatorProposalNotes
            onUpdate={onNoteUpdate}
            accountManagerNote={notes?.accountManager}
            brandRepresentativeNote={notes?.brandRepresentative}
            isForBrand={isForBrand}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProposalTileFooter;
